import axios from 'axios';

const TOKEN_KEY = 'accessToken';
const EXPIRES_AT_KEY = 'accessTokenExpiresAt'; // epoch ms

let refreshPromise = null;

const CLIENT_ID = 'av-client';
const CLIENT_SECRET = '7Z7zLCiejUWz3jK36fZAzQ9Ym8xH9vB6';

const TOKEN_URL = '/api/realms/virtualagency/protocol/openid-connect/token';

function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY) || '';
}

function getStoredExpiresAt() {
  const v = localStorage.getItem(EXPIRES_AT_KEY);
  return v ? Number(v) : 0;
}

function isTokenValid(bufferSeconds = 30) {
  const token = getStoredToken();
  const expiresAt = getStoredExpiresAt();
  if (!token || !expiresAt) return false;
  return Date.now() + bufferSeconds * 1000 < expiresAt;
}

async function fetchClientToken() {
  const form = new URLSearchParams();
  form.append('client_id', CLIENT_ID);
  form.append('grant_type', 'client_credentials');
  form.append('client_secret', CLIENT_SECRET);

  const { data } = await axios.post(TOKEN_URL, form, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    timeout: 60 * 1000,
  });

  // Keycloak geralmente retorna: access_token, expires_in, token_type
  const token = data.access_token;
  const expiresIn = Number(data.expires_in || 0);

  // salva com margem
  const expiresAt = Date.now() + expiresIn * 1000;

  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EXPIRES_AT_KEY, String(expiresAt));

  return token;
}

/**
 * Garante token válido.
 * - se já tiver válido: retorna imediatamente
 * - se não: busca e guarda
 * - protege contra múltiplas chamadas simultâneas (refreshPromise)
 */
export async function ensureAccessToken() {
  if (isTokenValid()) return getStoredToken();

  if (!refreshPromise) {
    refreshPromise = fetchClientToken()
      .catch((e) => {
        // limpa cache em erro
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(EXPIRES_AT_KEY);
        throw e;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
}

export function clearAccessToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRES_AT_KEY);
}
